'use client'

import type { RequestFormValues } from 'legal/types/requestFormTypes'
import { formatPrivacyFormRequest } from 'legal/utils/formatPrivacyFormRequest/formatPrivacyFormRequest'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { env } from 'utils/envManager'
import { url } from 'utils/url'

enum ORIGIN {
	WEB = 'Web',
	APP = 'App',
}
const SALESFORCE_FORM_ID = 'PRIVACY_POLICY'

export function useSubmitPrivacyRightsRequest() {
	const {
		channel,
		country: { countryISO, languageISO },
		isApp,
	} = useMasterData()
	const submit = async (values: RequestFormValues): Promise<boolean> => {
		const response = await fetch(
			url(`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-help-form/customer/case`),
			{
				headers: { 'Content-Type': 'application/json' },
				method: 'POST',
				body: JSON.stringify({
					formId: SALESFORCE_FORM_ID,
					channel,
					countryISO,
					languageISO,
					origin: isApp ? ORIGIN.APP : ORIGIN.WEB,
					...formatPrivacyFormRequest(values),
				}),
				next: { revalidate: 0 },
			}
		)
		return response.ok
	}

	return { submit }
}
